import { render, staticRenderFns } from "./CreateAttendanceDialog.vue?vue&type=template&id=37628691&"
import script from "./CreateAttendanceDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateAttendanceDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports